import React, { Component } from "react";

import { withReportFormats } from "../../../shared/containers/containerReportFormats";
import { withReportTime } from "../../../shared/containers/containerReportTime";
import { withSelectedReports } from "../../../shared/containers/containerSelectedReports";
import { withSelectedCars } from "../../../shared/containers/containerSelectedCars";
import { withDownloadReports } from "../../../shared/containers/containerDownloadReports";
import { withDownloadUnitReport } from "../../../shared/containers/containerDownloadUnitReport";
import { withSavedReports } from "../../../shared/containers/containerSavedReports";

import ButtonIconWrapper from "../../../shared/items/contols/buttonIconWrapper";
import TooltipWrapper from "../../../shared/items/contols/tooltipWrapper";

import getDates from "../../../shared/services/date.service";
import { states } from "../../../reducers/queriesStates";
import { withDeleteReport } from "../../../shared/containers/containerDeleteReport";

class DownloadAllReportsButton extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isActive: false,
      isInArchive: false,
    };

    this.getReportDates = this.getReportDates.bind(this);
    this.downloadReport = this.downloadReport.bind(this);
    this.downloadReports = this.downloadReports.bind(this);
    this.downloadUnitReport = this.downloadUnitReport.bind(this);
    this.downloadAllReports = this.downloadAllReports.bind(this);
  }

  componentDidMount() {
    const { reportFormatsDataState, onGetReportFormats, onGetSavedReports } = this.props;

    if (reportFormatsDataState !== states.READY) {
      onGetReportFormats();
    }

    onGetSavedReports();
  }

  componentDidUpdate(prevProps) {
    const { downloadReportsDataState, selectedReports, onGetSavedReports, downloadUnitReportDataState } = this.props;
    const { isActive } = this.state;

    if (downloadReportsDataState === states.REQUEST && prevProps.downloadReportsDataState !== states.REQUEST) {
      if (isActive) {
        this.downloadAllReports(selectedReports);
      }
    }

    if (downloadUnitReportDataState === states.READY && prevProps.downloadUnitReportDataState === states.REQUEST) {
      onGetSavedReports();
    }
  }

  getReportDates() {
    const { reportStartDate, reportStartTime, reportEndDate, reportEndTime, selectedReports } = this.props;
    const isDayInterval = selectedReports.length > 0 && selectedReports[0].requestInerval === 1;

    let startDate = new Date(reportStartDate);
    let startTime = new Date(reportStartTime);
    startDate.setHours(startTime.getHours());
    startDate.setMinutes(startTime.getMinutes());

    let endDate = new Date(reportEndDate);
    let endTime = new Date(reportEndTime);

    if (!isDayInterval) {
      endDate.setHours(endTime.getHours());
      endDate.setMinutes(endTime.getMinutes());
      endDate.setSeconds(59);
    } else {
      endDate.setHours(0);
      endDate.setMinutes(0);
      endDate.setSeconds(0);
      endTime.setHours(0);
      endTime.setMinutes(0);
      endTime.setSeconds(0);
    }

    return {
      startDate,
      endDate,
    };
  }

  downloadReport(report, car) {
    const { reportFormatsData, onDownloadReport } = this.props;
    let reportDates = this.getReportDates();
    let reportStartDate = reportDates.startDate;
    let reportEndDate = reportDates.endDate;
    let startDate = getDates.fixISOStringDateToPost(reportStartDate);
    let endDate = getDates.fixISOStringDateToPost(reportEndDate);
    let date = new Date();
    let options = {
      startDate: startDate,
      endDate: endDate,
      timeZone: date.getTimezoneOffset() / -60,
    };

    onDownloadReport(report, null, reportFormatsData[0], options);
  }

  downloadReports(report, selectedCars) {
    let carsList = [...selectedCars];

    if (carsList.length > 0) {
      this.downloadReport(report, carsList[0]);
      carsList.shift();
      this.downloadReports(report, carsList);
    }
  }

  downloadAllReports(selectedReports) {
    const { selectedCars } = this.props;
    let reportsList = [...selectedReports];

    if (reportsList.length > 0) {
      this.downloadReports(reportsList[0], selectedCars);
      reportsList.shift();
      this.downloadAllReports(reportsList);
    } else {
      this.setState({ isActive: false });
    }
  }

  downloadUnitReport() {
    const { selectedReports, selectedCars, reportFormatsData, onDownloadUnitReport } = this.props;
    const report = selectedReports[0];
    const reportDates = this.getReportDates();
    const reportStartDate = reportDates.startDate;
    const reportEndDate = reportDates.endDate;
    const startDate = getDates.fixISOStringDateToPost(reportStartDate);
    const endDate = getDates.fixISOStringDateToPost(reportEndDate);
    const date = new Date();
    const options = {
      units: selectedCars.map((x) => {
        return x.id;
      }),
      startDate: startDate,
      endDate: endDate,
      timeZone: date.getTimezoneOffset() / -60,
    };

    onDownloadUnitReport(report, null, reportFormatsData[0], options);
  }

  handleClick() {
    this.downloadUnitReport();
  }

  inAchive() {
    const { selectedReports, selectedCars, savedReportsData } = this.props;

    const reportDates = this.getReportDates();

    const reports = savedReportsData.filter((x) => {
      const startDate = new Date(Date.parse(x.startDate));
      const endDate = new Date(Date.parse(x.endDate));

      return (
        x.reportId === selectedReports[0].id &&
        getDates.equalsForMinutes(startDate, reportDates.startDate) &&
        getDates.equalsForMinutes(endDate, reportDates.endDate) &&
        x.units.length === selectedCars.length
      );
    });

    if (reports.length === 0) {
      return {
        inArchive: false,
      };
    }

    const archive = {
      inArchive: false,
      id: null,
    };

    reports.forEach((report) => {
      let allUnits = true;

      if (!archive.inArchive) {
        report.units.forEach((unit) => {
          if (allUnits) {
            allUnits = selectedCars.some((car) => {
              return car.id === unit.id;
            });
          }
        });

        if (allUnits) {
          archive.inArchive = true;
          archive.id = report.id;
        }
      }
    });

    return archive;
  }

  render() {
    const { reportStartDate, reportStartTime, reportEndDate, reportEndTime, selectedReports, selectedCars, onDeleteReport } = this.props;

    const isDisabled =
      selectedReports.length === 0 ||
      selectedCars.length === 0 ||
      !reportStartDate ||
      !reportStartTime ||
      !reportEndDate ||
      !reportEndTime ||
      isNaN(reportStartDate) ||
      isNaN(reportStartTime) ||
      isNaN(reportEndDate) ||
      isNaN(reportEndTime);

    let inArchive = false;
    let archive = null;
    if (!isDisabled) {
      archive = this.inAchive();
    }

    const type = archive !== null && archive.inArchive ? "green" : "primary";

    return (
      <div style={{ display: "flex" }}>
        <TooltipWrapper
          title={`Скачать${archive !== null && archive.inArchive ? " из архива " : ""} ${
            selectedReports.length > 0 ? '"' + selectedReports[0].title + '"' : "отчет "
          } для всего выбранного транспорта`}
          position="left"
        >
          <div style={{ display: "flex" }}>
            <ButtonIconWrapper type={type} icon="save" disabled={isDisabled} handleClick={this.handleClick.bind(this)} />
          </div>
        </TooltipWrapper>

        {archive !== null && archive.inArchive ? (
          <TooltipWrapper
            title={`Удалить из архива ${selectedReports.length > 0 ? '"' + selectedReports[0].title + '"' : "отчет "}`}
            position="left"
          >
            <div style={{ marginLeft: "8px" }}>
              <ButtonIconWrapper
                type={"primary"}
                icon="delete"
                disabled={isDisabled}
                handleClick={(e) => {
                  onDeleteReport(archive.id);
                }}
              />
            </div>
          </TooltipWrapper>
        ) : null}
      </div>
    );
  }
}

export default withDownloadUnitReport(
  withDeleteReport(
    withSavedReports(
      withDownloadReports(withSelectedCars(withSelectedReports(withReportTime(withReportFormats(DownloadAllReportsButton)))))
    )
  )
);
